// Business details shown across the site. Edit here to update every page.
const siteConfig = {
  businessName: "Henry Pham's Landscaping & Gardening",
  shortName: "Henry's Landscaping",
  phoneDisplay: '(206) 849-6209',
  phoneHref: 'tel:+1-206-849-6209',
  smsHref: 'sms:+1-206-849-6209',
  serviceArea: 'the Seattle area',
  availability: 'Available any time — call or text',
};

export const services = [
  {
    title: 'Lawn & Garden Care',
    icon: 'eco',
    items: [
      'Mowing, edging & fertilizing',
      'Weed removal & moss control',
      'Flower beds & gravel',
    ],
  },
  {
    title: 'Lawn Installation',
    icon: 'naturePeople',
    items: [
      'New lawn installation',
      'Reseeding & sod',
      'Beauty bark & topsoil',
    ],
  },
  {
    title: 'Trees & Shrubs',
    icon: 'nature',
    items: [
      'Pruning & trimming',
      'Tree cutting',
      'Brush clearing',
    ],
  },
  {
    title: 'Cleanup & Hauling',
    icon: 'cleanup',
    items: [
      'Leaf cleanup',
      'Demolition & salvage',
      'Junk removal',
    ],
  },
  {
    title: 'Fences & Retaining Walls',
    icon: 'fence',
    items: [
      'Fence installation',
      'Retaining walls',
    ],
  },
  {
    title: 'Pressure Washing',
    icon: 'water',
    items: [
      'Wooden decks',
      'Driveways',
      'Sidewalks',
    ],
  },
];

export default siteConfig;
